import store from '@/store/index'

/**
 * 跳转方法处理
 * @param {*} path 跳转路径
 * @param {*} prams 跳转传参
 * @param {*} type 跳转类型，
 */
export const toPage = (path,params,type='push', target = 'self') => {
  window.parent.postMessage({
    tag:'__atmAdminVue__',
    fnName:'jumpPage',
    fnParams:{
      path,
      params,
      type,
      target
    }
  },store.state.atmStore.atmWebOrigin);
}

//无效登出
export const invalidLogin = () => {
  window.parent.postMessage({
    tag:'__atmAdminVue__',
    fnName:'invalidLogin'
  },store.state.atmStore.atmWebOrigin);
}

export const downloadFile = (data, fileName) => {
  let blob = new Blob([data]);
  // 获取heads中的filename文件名
  let downloadElement = document.createElement('a');
  // 创建下载的链接
  let href = window.URL.createObjectURL(blob);
  downloadElement.href = href;
  // 下载后文件名
  downloadElement.download = fileName;
  document.body.appendChild(downloadElement);
  // 点击下载
  downloadElement.click();
  // 下载完成移除元素
  document.body.removeChild(downloadElement);
  // 释放掉blob对象
  window.URL.revokeObjectURL(href);
}
